// extracted by css-extract-rspack-plugin
module.exports =  {"annotation-input":"Input-jpxd__annotation-input","form-actions":"Input-in3V__form-actions","save-path":"Input-LQzy__save-path","save-button":"Input-cAkL__save-button"};